import React from "react";

const TicketDetails = ({ ticket }) => {
  return (
    <div className="card p-1">
      <h5 className="mb-3">Details</h5>

      {ticket?.description ? (
        <p className="mb-0" style={{ whiteSpace: "pre-line" }}>
          {ticket.description}
        </p>
      ) : (
        <p className="text-muted mb-0">No description available</p>
      )}
    </div>
  );
};

export default TicketDetails;
